import React from "react"
import Headline from "../atoms/Headline"
import Link from "../atoms/Link"

const StaticDownloadsBlock = ({ block }) => {
  const formatExtension = (extension) => {
    let formatedExtention = extension.replace(".", "").toUpperCase()
    return formatedExtention
  }

  return (
    <section className="static-downloads-block">
      <div className="static-downloads-block-container">
        <div className="static-downloads-block-wrapper">
          <div className="static-downloads-block-row">
            <div className="static-downloads-block-cell">
              <div className="static-downloads-block-cell-wrapper">
                {block.file_downloads?.length > 0 && (
                  <>
                    <Headline
                      headline={block.headline}
                      subheadline={block.description}
                    />
                    <ul className="static-downloads-block-static-downloads download-list">
                      {block.file_downloads.map((item, index) => (
                        <li key={index}>
                          <Link link={item.file}>
                            {item.title}
                            <small>{formatExtension(item.extension)}</small>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default StaticDownloadsBlock
